// extracted by mini-css-extract-plugin
export var quillEditor = "_pa-1";
export var variable = "_pa-0";